module.exports = __webpack_public_path__ + "static/media/image.46e94886.png";